import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';

import MainLayout from './Main';
import Menu from '../components/Menu';
import Head from '../components/Head';
import { SidesContainer } from '../components/Container';
import Pagination from '../components/Pagination';
import { usePreparedWorkItems } from '../utils/hooks';
import * as css from './Project.module.css';
import * as grid from '../styles/grid.module.css';

const ProjectLayout = ({ title, children }) => {
  const data = useStaticQuery(query);
  const pages = usePreparedWorkItems(data.pages.nodes);
  const index = data.pages.nodes.findIndex(
    node => node.childJavascriptFrontmatter.frontmatter.title === title
  );

  return (
    <MainLayout>
      <Helmet
        bodyAttributes={{
          class: `invert ${grid.invert}`
        }}
      />
      <Head title={title} description={pages[index]?.description} />
      <Menu />
      <SidesContainer topLine bottomLine>
        <div className={classnames(grid.col, css.heading)}>
          <h1>{title}</h1>
        </div>
      </SidesContainer>

      {children}
      <Pagination pages={pages} index={index} />
    </MainLayout>
  );
};

const query = graphql`
  query {
    pages: allFile(
      filter: { fields: { section: { eq: "work" } } }
      sort: {
        fields: childrenJavascriptFrontmatter___frontmatter___order
        order: ASC
      }
    ) {
      nodes {
        childJavascriptFrontmatter {
          frontmatter {
            title
            description
          }
        }
        fields {
          slug
          section
        }
      }
    }
  }
`;

export default ProjectLayout;
